import { makeHttpClient, _unwrapAxiosResponse } from "./http";
import env from "@/environment/env.json";
import { DialogProgrammatic as Dialog } from "buefy";
export interface ReportingCategory {
  /** TODO: Fill with attributes */
  id?: number;
  placeholder: string;
  customer: number;
  country: number;
  scheme: number;
  stream: number;
  report: number;
  reporting_main_category: number;
  reporting_category: number;
  reporting_sub_category: number;
  valid_from: Date;
  valid_to: Date;
  short_report_name: string;
  example_of_product: string;
  additional_info: string;
}
function dateFormatter(dt: any) {
  if (dt == "Invalid Date") {
    return null;
  }
  if (dt != null) {
    return dt.toLocaleDateString("fr-CA");
  }
  return dt;
}
export default class ReportingCategoryService {
  private httpClient = makeHttpClient();

  export(ids: number[], customerId: number) {
    const params = new URLSearchParams();
    if (ids.length == 0) {
      throw new Error("NOTHING TO EXPORT");
    } else {
      ids.map(id => {
        params.append("id", "" + id);
      });
      const url = `${
        env.customerUrl
      }rc/export/?customer_id=${customerId}&${params.toString()}`;
      this.httpClient
        .get(url, { responseType: "blob" })
        .then(({ data }) => {
          const downloadUrl = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "CustomerReportingCategory.xlsx"); //any other extension
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(err => {
          Dialog.alert({
            title: "Export not possible",
            message:
              "There was an error exporting reporting category. Please contact your Customer Account Manager.",
            type: "is-danger",
            ariaRole: "alertdialog",
            ariaModal: true
          });
          return err;
        });
    }
  }

  exportReportingTemplateMethod(customerId: number) {
    const url = `${env.customerUrl}rc/template/export/?customer_id=${customerId}`;
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "ReportingTemplate.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(err => {
        Dialog.alert({
          title: "Export not possible",
          message:
            "There was an error exporting reporting template. Please contact your Customer Account Manager.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return err;
      });
  }
  fetchReportingCategoryHistory(customer_id: number) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportingCategory>(
        env.customerUrl + "rc/history/?customer_id=" + customer_id
      )
    );
  }

  exportReportingCategoryHistory(customer_id: number) {
    const url = `${env.customerUrl}export/rc/history/?customer_id=${customer_id}`;
    this.httpClient
      .get(url, { responseType: "blob" })
      .then(({ data }) => {
        const downloadUrl = window.URL.createObjectURL(new Blob([data]));
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute("download", "CustomerReportingCategoryHistory.xlsx"); //any other extension
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch(err => {
        Dialog.alert({
          title: "Export not possible",
          message:
            "There was an error exporting reporting category history. Please contact your Customer Account Manager.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return err;
      });
  }

  getAll(customer_id: number, query: any) {
    if (query) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ReportingCategory>(
          env.customerUrl +
            "reporting/category/?customer_id=" +
            customer_id +
            "&" +
            query
        )
      );
    }
    if (customer_id && !isNaN(customer_id)) {
      return _unwrapAxiosResponse(
        this.httpClient.get<ReportingCategory>(
          env.customerUrl + "reporting/category/?customer_id=" + customer_id
        )
      );
    }
  }

  getSingleReportingCategory(customer_id: number, reporting_category: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportingCategory>(
        env.customerUrl +
          "reporting/category/" +
          reporting_category +
          "/?customer_id=" +
          customer_id
      )
    );
  }

  create(form: any) {
    const data = {
      customer: form.customer,
      country: form.country,
      scheme: form.scheme,
      stream: form.stream,
      report: form.report,
      reporting_main_category: form.reporting_main_category,
      reporting_category: form.reporting_category_id,
      reporting_sub_category: form.reporting_sub_category,
      valid_from: dateFormatter(form.valid_from),
      valid_to: dateFormatter(form.valid_to),
      short_report_name: form.short_report_name,
      example_of_product: form.example_of_product,
      additional_info: form.additional_info
    };
    return _unwrapAxiosResponse(
      this.httpClient.post<ReportingCategory>(
        env.customerUrl + "reporting/category/",
        data
      )
    );
  }

  update(form: any) {
    const data = {
      customer: form.customer,
      country: form.country,
      scheme: form.scheme,
      stream: form.stream,
      report: form.report,
      reporting_main_category: form.reporting_main_category,
      reporting_category: form.reporting_category_id,
      reporting_sub_category: form.reporting_sub_category,
      valid_from: dateFormatter(form.valid_from),
      valid_to: dateFormatter(form.valid_to),
      short_report_name: form.short_report_name,
      example_of_product: form.example_of_product,
      additional_info: form.additional_info
    };
    return _unwrapAxiosResponse(
      this.httpClient.put<ReportingCategory>(
        env.customerUrl + "reporting/category/" + form.id + "/",
        data
      )
    );
  }

  changeWorkflowStatus(
    customerId: number,
    status: string,
    reject_reason: string,
    categoryId: number
  ) {
    return _unwrapAxiosResponse(
      this.httpClient.post<ReportingCategory>(
        env.customerUrl +
          `rc/workflow/?id=${categoryId}&customer_id=${customerId}&status=${status}` +
          (reject_reason ? `&reject_reason=${reject_reason}` : "")
      )
    );
  }

  delete(cred_id: any) {
    const url = env.customerUrl + "reporting/category/" + cred_id + "/";
    return _unwrapAxiosResponse(this.httpClient.delete<ReportingCategory>(url));
  }

  getReportingTypes(form: any) {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportingCategory>(
        "/api/reportingcategories/?country=" +
          form.country +
          "&scheme=" +
          form.scheme +
          "&stream=" +
          form.stream
      )
    );
  }

  getAllReportingTypes() {
    return _unwrapAxiosResponse(
      this.httpClient.get<ReportingCategory>("/api/all/reportingcategories/")
    );
  }
}
